export default (theme) => ({
    root: {
        ...theme.typography.body,
        color: theme.colors.textDark.primary,
        backgroundColor: theme.colors.primary.black,
        borderRadius: '0 4px 4px 0',
        padding: '9px 16px 9px 12px',
        whiteSpace: 'nowrap',
        height: 40,
        left: 52,
    },
});
